var track = {
    text1:"POINTS EARNED:",
    pending:"PENDING",
    available:"AVAILABLE TO REDEEM",
    text2:"Current Bookings",
    bookingSource: "Booking Via",
    bookingNumber: "Booking Number",
    clientName: "Client Name",
    resort: "Resort",
    room: "Room Type",
    points: "Points Earned",
    status: "Status",
    remptioHistory: "Redemption History:",
    pointsRedeemed: "Points Redeemed",
    rewardType: "Reward Type",
    dateReddem: "Date",
    awardboxText1: "Redeem an Award:",
    awardboxText2:"Award Type",
    awardboxText3:"Points To Redeem",
    awardboxSelect:"Select",
    awardboxText4:"Add another row +",
    awardboxText5:"Remove row -",
    awardboxText6:"Please send my reward(s) to:",
    awardboxFielName:"Full Name",
    awardboxFielEmail:"Email",
    awardboxFielStreet:"Street",
    awardboxFielApt:"Apt#",
    awardboxFielCity:"City",
    awardboxFielProvince:"State/Province",
    awardboxFielZip:"Zip Code",
    awardboxFielCountry:"Country",
    awardboxFielBankName:"Bank Name",
    awardboxFielBankClabe:"# Clabe",
    awardboxFielBankAccount:"# Bank Account",
    awardboxFielBankBeneficiary:"Account Beneficiary",
    awardboxFielCurp:"CURP",
    awardboxFielRfc:"RFC",
    sendbtn: "Send",
    note: "Note: Award will be mailed. Certificates for hotel stays will be emailed.",
    error: "Select Award Type and points",
    error2: "Enter Full Name",
    error3: "Enter Email",
    error4: "You cannot redeem, you only have 0 points available.",
    records: "0 Records",
    loading: "Loading...",
    note1:"You cannot use more than two rooms on the same date.",
    note2:"(Blackout dates apply such as for Easter, Thanksgiving, Holy Week)",
    processingNoticeTitle:"Processing information",
    processingNoticeLead:"Requests are processed in the order they are received and may take 7 to 10 business days.",
    processingNoticeBody:"Once approved and processed, Tango gift cards will be emailed directly to the qualifying agent.",
    processingNoticeImportantTitle:"Important for Tango gift card requests",
    processingNoticeImportantBody:"Please include a copy of your completed TAX ID form so we can process your request on time. Send TAX ID forms to marivalrewards@marivalresorts.com.",
    processingNoticeBlackout:"Blackout dates may apply during Easter, Summer, Thanksgiving, Holy Week, and Mexican holidays.",
    Total_Points:"TOTAL POINTS",


    redeem_a: "To redeem your complimentary stay at Marival Armony or Marival Distinct, you must accumulate 6 points with bookings from these Resorts.  Points for bookings at these two properties are combinable.",
    redeem_b: "Bookings made at Marival Emotions do not qualify for stays at Marival Armony or Marival Distinct.",
    redeem_c: "Bookings made at Marival Armony or Marival Distinct may also be redeemed for stays at Marival Emotions in a one bedroom Suite or Resort room.",
    redeem_d: "To redeem your complimentary stay at Marival Emotions in a one bedroom Suite, you must accumulate 6 points with bookings in any of our Suite categories at Marival Emotions, or any booking at Marival Armony and Marival Distinct.",
   
    redeem_e: "Bookings made in the Suites categories may also be redeemed for stays at Marival Emotions in a Resort room.",
  
    redeem_f: "Bookings made in the Resort category do not qualify for stays in a one bedroom Suite at Marival Emotions, nor for stays at Marival Armony and Marival Distinct.",

    redeem_g:"To redeem your complimentary stay sat Marival Emotions in a Resort room, you must accumulate 6 points with bookings in any category at any of our three Resorts.",
   
    redeem_h: "All bookings at our three Resorts qualify for a stay in a Resort room at Marival Emotions.",
    


    redeem_a_1:"To redeem your complimentary stay at Marival Armony or Marival Distinct, you must have validated registered bookings at either Armony or Distinct to qualify.",
    redeem_b_1: "Bookings made at Marival Emotions do not qualify for stays at Marival Armony or Marival Distinct.",
    redeem_c_1: "Bookings made at Marival Armony or Marival Distinct may also be redeemed for stays at Marival Emotions.",
    redeem_d_1: "Confirmed complimentary stays will be processed in standard room categories at each resort.  Room upgrades are subject to availability and/or additional cost.  Which agent will be responsible for.  ",
    redeem_e_1: "",
    redeem_f_1: "",
    redeem_g_1: "",
    redeem_h_1: ""
}
module.exports = track
